import axios from 'axios';
import moment from "moment";
import { utilityService } from '@/services/utilityService.js';

export const trackService = {
	getTrackAggregate,
	// Returns GEO_JSON track point representation based on a track point Id
    getTrack,

	// Returns the numbers of tracks based on: study, start and end times
    getTrackCounts,

	// Returns GEO_JSON track objects based on: study, staff Id and source(laptop or phone)
    getStaffLastReceivedGpsTrack,

	// Returns GEO_JSON track objects based on: study, task ID
	getTracksByTaskId,

	// Returns the GEO_JSON track objects based on: study, staffId, GPS source (laptop or phone), start and end dates
	getAllTracksForDay
};
// #region track

function getTrackAggregate(criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`track/find/agg/staff?studyCode=${criteria.study}&staffId=${criteria.staff}&dateStart=${criteria.startdate}&dateEnd=${criteria.enddate}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getTrack(study, uuid) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`track?studyCode=${study}&uuid=${uuid}&format=geojson`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getTrackCounts(criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`track/count/?studyCode=${criteria.study}&start=${criteria.startdate}&end=${criteria.enddate}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getStaffLastReceivedGpsTrack(criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`track/staff/lasttrack/?studyCode=${criteria.study}&gpsSource=${criteria.gpssource}&id=${criteria.id}&format=geojson`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getTracksByTaskId(criteria) {
	console.log("getTracksByTaskId criteria: ", criteria)
	return axios.get(utilityService.buildFullyQualifiedUrl(`track/find/radius?studyCode=${criteria.study}&format=GEO_JSON&taskUuid=${criteria.taskUUID}&staffId=${criteria.staffId}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getAllTracksForDay(criteria) {
	console.log("getAllTracksForDay criteria: ", criteria)
	let onlyDate = criteria.dateStart.substring(0, 10);
  	let date2 = moment(onlyDate).add(1, "days").format("YYYY-MM-DD");
	let finalStartdate = onlyDate + "T00:00:00Z";
	let finalEnddate = date2 + "T00:00:00Z";
	console.log("finalStartdate", finalStartdate);
	console.log("finalEnddate", finalEnddate);

	let trackFindUrl;
	if(!criteria.source) {
		trackFindUrl = `track/find?studyCode=${criteria.study}&staffId=${criteria.staffId}&dateStart=${finalStartdate}&dateEnd=${finalEnddate}&format=GEO_JSON`
	} else {
		trackFindUrl = `track/find?studyCode=${criteria.study}&staffId=${criteria.staffId}&dateStart=${finalStartdate}&dateEnd=${finalEnddate}&source=${criteria.source}&format=GEO_JSON`
	}
	return axios.get(utilityService.buildFullyQualifiedUrl(trackFindUrl),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// #endregion track
